import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '@/store';
import { Enterprise } from '@/store/types/public/Enterprise';
import PubHttp from '@/PubHttp';
import { PageMeta } from '@/store/types/pagination';

export const NAMESPACE = 'pub/enterprises';

export interface EnterprisesState extends RootState {
  items: Enterprise[],
  item?: Enterprise
}

export const state: EnterprisesState = {
  status: null,
  items: [],
  item: undefined,
  meta: undefined
};

export const getters: GetterTree<EnterprisesState, any> = {
  items: (state):any => state.items,
  item: (state) => state.item,
  status: (state):boolean|null => state.status,
  loading: (state):boolean => state.status === null,
  meta: (state):PageMeta|undefined => state.meta
};

export const actions: ActionTree<EnterprisesState, RootState> = {
  request: ({ commit, rootGetters }:any, filter:any = {}) => {
    commit('request');
    (new PubHttp()).request({ url: `enterprises`, params: filter })
      .then((resp:any) => {
        commit('success', resp.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  show: ({ state, commit, rootGetters }:any, id:number) => {
    commit('request');
    commit('setItem', { id: id });
    state.items.forEach((item:Enterprise) => {
      if (item.id === id) {
        commit('setItem', item);
      }
    });
    (new PubHttp()).request({ url: `enterprises/${id}` })
      .then((resp:any) => {
        commit('successShow', resp.data.data);
      })
      .catch(() => {
        commit('error');
      });
  }
};

export const mutations: MutationTree<EnterprisesState> = {
  request: (state) => {
    state.status = null;
  },
  error: (state) => {
    state.status = false;
  },
  success: (state, resp:{data: Enterprise[], meta?: PageMeta}) => {
    state.status = true;
    state.items = resp.data;
    state.meta = resp.meta;
  },
  setItem: (state, data:Enterprise) => {
    state.item = data;
  },
  successShow: (state, data:Enterprise) => {
    state.item = data;
    state.status = true;
  }
};

export const enterprises: Module<EnterprisesState, any> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
